import { DIMENSIONS } from '../../content'
import { prog, pv } from '../../motion'
import { BeamBands } from '../../primitives'
import { Fit, Line } from '../kit'

// Ein schwarzer Würfel dreht sich mit dem Scroll und wird gläsern
const FACES = [
  'translateZ(150px)',
  'rotateY(180deg) translateZ(150px)',
  'rotateY(90deg) translateZ(150px)',
  'rotateY(-90deg) translateZ(150px)',
  'rotateX(90deg) translateZ(150px)',
  'rotateX(-90deg) translateZ(150px)'
]

const SPIN = 'calc(var(--p) * 400deg + 25deg)'

export default function CinCube() {
  return (
    <div className='cin-full'>
      <div className='cin-cube-head'>
        <Line
          at={[0, 0.08]}
          out={[0.3, 0.36]}
          className='cin-title cin-title--center'
        >
          Eine Black Box will Vertrauen.
        </Line>
        <Line
          at={[0.38, 0.46]}
          out={[0.64, 0.7]}
          className='cin-title cin-title--center'
        >
          Aivy zeigt dir, wie es rechnet.
        </Line>
        <Line at={[0.72, 0.8]} className='cin-title cin-title--center'>
          Im Kern ohne KI.{' '}
          <span className='cin-muted-light'>
            Regelbasiert, nachvollziehbar, prüfbar.
          </span>
        </Line>
      </div>

      <Fit w={420} h={420} maxH={0.5} maxW={0.8} className='cin-cube-fit'>
        <div
          className='cin-cube'
          style={{
            ...prog([0, 0.78]),
            ...pv('q', [0.34, 0.5]),
            ...pv('z', [0.68, 0.86]),
            transform: `rotateX(-22deg) rotateY(${SPIN})`
          }}
        >
          {FACES.map((t, i) => (
            <div key={i} className='cin-cube__face' style={{ transform: t }}>
              <span>?</span>
            </div>
          ))}

          <div
            className='cin-cube__core'
            style={{
              transform: `translate(-50%, -50%) rotateY(calc(-1 * ${SPIN})) rotateX(22deg) scale(calc(1 + 0.45 * var(--z)))`
            }}
          >
            {DIMENSIONS.map((d) => (
              <div key={d.name} className='cin-core-row'>
                <span>{d.name}</span>
                <div className='cin-core-row__track'>
                  <BeamBands ideal={d.ideal} trans={d.trans} />
                  <i
                    className='cin-core-row__dot'
                    style={{ left: `${d.lena}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Fit>
    </div>
  )
}
